/**
 * A contact's name/badge status, task: deferred badge OCR (2026-09-08).
 *
 * One source of truth, shared by ContactRow.jsx, Home.jsx and EditContact.jsx,
 * so the three never drift on what "needs typing" means:
 *
 *   named       has a first name, nothing to do
 *   no_photo    no name and no badge photo either; nothing will ever fill
 *               this in automatically, so it needs typing right now
 *   unreadable  has a photo, badge_ocr_attempted_at is set, still no name;
 *               OCR genuinely ran and found nothing, so this needs typing
 *               too, not more waiting
 *   pending     has a photo, badge_ocr_attempted_at is not set yet; still
 *               processing, resolves itself automatically within seconds
 *               of syncing, nothing for a rep to do
 *
 * "needs typing" (no_photo or unreadable) is the actionable subset: the
 * Home banner and its filtered list count and show only these, not pending
 * ones, so a rep sees what to fix rather than what is merely still working.
 */
export function badgeStatus(contact) {
  if (contact.first_name?.trim()) return 'named';
  if (!contact.badge_image_key) return 'no_photo';
  if (contact.badge_ocr_attempted_at) return 'unreadable';
  return 'pending';
}

export function needsTyping(contact) {
  const status = badgeStatus(contact);
  return status === 'no_photo' || status === 'unreadable';
}

export function isIncomplete(contact) {
  return badgeStatus(contact) !== 'named';
}
